// To show Brand filteration

document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".filter-btn");
  const cards = document.querySelectorAll(".brand-card");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      const filter = btn.getAttribute("data-filter");

      cards.forEach(card => {
        if (filter === "all" || card.classList.contains(filter)) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const faqContainers = document.querySelectorAll(".faq-accordion");
  if (faqContainers.length === 0) return;

  faqContainers.forEach((faqContainer) => {
    faqContainer.addEventListener("click", function (event) {
      const question = event.target.closest(".faq-question");
      if (!question) return;

      const faqId = question.dataset.faqId;
      const answer = document.getElementById(faqId);

      // Close all others inside this accordion
      faqContainer.querySelectorAll(".faq-question").forEach((btn) => {
        if (btn !== question) btn.classList.remove("active");
      });
      faqContainer.querySelectorAll(".faq-answer").forEach((ans) => {
        if (ans !== answer) ans.style.display = "none";
      });

      // Toggle current
      question.classList.toggle("active");
      if (answer) {
        answer.style.display = question.classList.contains("active") ? "block" : "none";
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const colorContainers = document.querySelectorAll('.variant-colors');

  colorContainers.forEach(container => {
    const swatches = container.querySelectorAll('.variant-color-swatch:not(.more)');
    if (swatches.length > 5) {
      const moreCount = swatches.length - 5;

      // Create the "+N" swatch
      const moreSwatch = document.createElement('span');
      moreSwatch.classList.add('variant-color-swatch', 'more');
      moreSwatch.textContent = `+${moreCount}`;

      container.appendChild(moreSwatch);
    }
  });
});

$(document).ready(function () {

    // First FAQ open by default
    $('.contact-faq__item:first .contact-faq__answer').show();
    $('.contact-faq__item:first .faq-icon').text('−');

    $('.contact-faq__question').click(function () {

        var parent = $(this).parent();

        if (parent.hasClass('active')) {

            parent.removeClass('active');
            parent.find('.contact-faq__answer').slideUp(300);
            parent.find('.faq-icon').text('+');

        } else {

            $('.contact-faq__item').removeClass('active');
            $('.contact-faq__answer').slideUp(300);
            $('.faq-icon').text('+');

            parent.addClass('active');
            parent.find('.contact-faq__answer').slideDown(300);
            parent.find('.faq-icon').text('−');

        }

    });

});